module.exports = __webpack_public_path__ + "static/media/bg-accommodation-detail.af267644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-accommodation-detail.jpg
// module id = 1278
// module chunks = 0